module.exports = __webpack_public_path__ + "static/250523_3M-2025_Financial_Reporting-008472c57e81ec252ebb8d1e4384ce1f.pdf";